import React, { Component } from "react"
import ButtonsForm from "../../../components/ButtonsForm"
import { Link, Redirect } from 'react-router-dom'
import auth from "../../../utils/auth"
import cfg from "../../../utils/config"
import axios from "axios"
import helper from "../../../utils/helper"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs' 
import GridDevices from "./dispositivos/grid"
import GridMulticastGroups from "./gruposMulticast/grid"
import Select from '../../../components/Select'

import { getClientesModulo, createOptionsClientes } from "../../../services/clientes"

class Form extends Component {
    userInfo = auth.getUserInfo()
    isCustomer = auth.isClient()

    state = {
        detalhes: { name: null, description: null, cliente: this.isCustomer ? { label: this.userInfo.nome, value: this.userInfo.cliente } : { label:"Nenhum", value: null } },
        cooldown: false,
        redirect: false,
        path: "",
        tab: 0,
        optionsClientes: [{label:"Nenhum", value: null}],
        tabDisabled: true,
        permissaoDipositivo: true,
        permissaoGrupoMulticast: true,
        savedClient: null,
    }

    get applicationId() {
        if (this.props.isQuickRegister && this.props.applicationId) {
            return this.props.applicationId;
        }

        return this.props?.match?.params?.id;
    }
    componentDidMount = async () => {
        if(!auth.isMasterOrAdmin()) {
            this.setState({
                permissaoDipositivo: "/device" in this.userInfo.permissions,
                permissaoGrupoMulticast: "/multicast/group" in this.userInfo.permissions
            })
        }

        await getClientesModulo('lns').then((clientes) => this.setState({ optionsClientes: [...this.state.optionsClientes, ...createOptionsClientes(clientes)] }) )

        if (this.applicationId) {
            this.getData()
        } 
    }

    getData = () => {
        const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/application/' + this.applicationId + '/'
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        axios.get(requestURL, config_me).then(({ data }) => {
            const clientes = this.state.optionsClientes
            const cliente = clientes.find((item) => item.value == data.cliente) ??  {label:"Nenhum", value: null}

            this.setState({ 
                detalhes: { name: data.name, description: data.description, cliente }, 
                tabDisabled: false,
                tab: this.props?.match?.params?.idTab ? Number(this.props?.match?.params?.idTab) : 0,
                savedClient: data.cliente
            })
        })
    }

    handleChange = (field, value) => {
        if (field == "cliente" && (this.applicationId && value?.value != this.state?.savedClient)) {
            helper.dispatchEvent("showAviso", {
                message: "Alterar o cliente pode causar inconsistências nos dados dos redirecionamentos já existentes. Certifique-se de atualizar os demais registros relacionados caso essa mudança seja mantida."
            })
        }
        const detalhes = Object.assign({}, this.state.detalhes)
        const span = document.getElementById(`validacao-${field}`)

        detalhes[field] = value
        
        if(span) {
            span.innerHTML = ""
        }

        this.setState({ detalhes })
    }

    handleQuickRegister = async () => {
        return new Promise((resolve) => {
            this.saveAction(false, resolve);
        });
    };

    saveAction = (novoCadastro, resolve = null) => {
        const { detalhes } = this.state

        this.setState({ cooldown: true })

        let requestURL = ""
        let verb = ""

        if (this.applicationId) {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/application/' + this.applicationId + '/'
            verb = 'patch'
        } else {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/application/'
            verb = 'post'
        }

        let data = {
            name: detalhes.name,
            description: detalhes.description,
            cliente: detalhes.cliente.value
        }

        axios({
            method: verb,
            url: requestURL,
            data: data,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then((res) => {
            if (novoCadastro) {
                window.location.reload()
            } else {

                helper.dispatchEvent("showAviso", {
                    message: `Aplicação ${verb === "post" ? "criada" : "editada"} com sucesso.`,
                    callback: () => {
                        if (this.props.isQuickRegister) {
                            if (resolve) {
                                resolve({
                                    success: true,
                                    applicationId: res.data.id,
                                })
                            }

                            return
                        }
                        this.setState({ redirect: true, path: "/lns/application" })
                    },
                    callbackClose: () => {
                        if (this.props.isQuickRegister) {
                            if (resolve) {
                                resolve({
                                    success: true,
                                    applicationId: res.data.id,
                                })
                            }

                            return
                        }
                        if (verb === "post") {
                            window.location.href = `/lns/application/${res.data.id}/editar`
                            setTimeout(() => { window.location.reload() }, 1000)
                        }
                    }
                })
            }
        }).catch((error) => {
            if (resolve) {
                resolve({
                    success: false,
                })
            }

            if (typeof error.response?.data === "string") {
                helper.dispatchEvent("showAviso", {
                    message: error.response.data
                })

                return
            }

            let erros = Object.entries(error.response?.data || {})

            if (Array.isArray(erros)) {
                for (let i = 0; i < erros.length; i++) {
                    let span = document.querySelector(`#validacao-${erros[i][0]}`)
                    if (span) span.innerHTML = erros[i][1]
                }
            }
        })

        setTimeout(() => this.setState({ cooldown: false }), 1000)
    }

    handleTab = (index) => this.setState({ tab: index })

    renderNameAndDescriptionFormContent = () => {
        const { detalhes, edit } = this.state;

        return (
            <div className="hdv-form-default">
                <div className="row">
                    <div className="col-md-12">
                        <label className="required">Cliente</label>
                        <Select
                            disabled={edit || this.isCustomer}
                            value={detalhes.cliente}
                            options={this.state.optionsClientes}
                            onChange={(e) => this.handleChange("cliente", e)}
                        />
                        <span id="validacao-cliente"></span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <label className="required" htmlFor="name">Nome</label>
                        <input
                            type="text"
                            value={detalhes.name ?? ""}
                            id="name"
                            onChange={(e) => this.handleChange("name", e.target.value)}
                        />
                        <span id="validacao-name"></span>
                    </div>

                    <div className="col-md-6">
                        <label className="required" htmlFor="description">Descrição</label>
                        <input
                            type="text"
                            value={detalhes.description ?? ""}
                            id="description"
                            onChange={(e) => this.handleChange("description", e.target.value)}
                        />
                        <span id="validacao-description"></span>
                    </div>
                </div>
            </div>
        );
    };
    
    render() {
        const { detalhes, tab, tabDisabled, permissaoDipositivo, permissaoGrupoMulticast } = this.state
        const edit = this.applicationId ? true : false

        if (this.state.redirect) {
            return <Redirect to={this.state.path} />
        }

        return (
            <div>
                {!this.props.isQuickRegister &&
                    <div className="hdv-default-header mx-3">
                        <span className="screen-menu-desc">
                            {!this.props.isQuickRegister &&
                                <i
                                    className="fa fa-info-circle fa-20px"
                                    title='Informações do Cadastro de Aplicações'
                                    style={{
                                        cursor: "pointer",
                                        marginRight: '5px',
                                        marginTop: '10px',
                                    }}
                                    onClick={() =>
                                        helper.dispatchEvent("showAviso", {
                                            message:
                                                `As Aplicações representam um agrupamento de dispositivos relacionados.
                                                Use para organizar seus dispositivos por projeto, localidade ou cliente.`,
                                        })
                                    }
                                />
                            }
                            {this.applicationId ? <h4>Editar Aplicação</h4> : <h4>Nova Aplicação</h4>}
                            <div className="gray-background">
                                <i className="las la-project-diagram la-2x"></i>
                            </div>
                        </span>
                    </div>
                }


                {!this.props.isQuickRegister ?
                    <Tabs className="tabs-style" selectedIndex={tab} onSelect={(i) => this.handleTab(i)}>
                        <TabList>
                            <Tab>Nome e Descrição</Tab>
                            <Tab disabled={tabDisabled || !permissaoDipositivo}>Dispositivos</Tab>
                            <Tab disabled={tabDisabled || !permissaoGrupoMulticast}>Grupos Multicast</Tab>
                        </TabList>

                        <TabPanel>
                            {this.renderNameAndDescriptionFormContent()}
                        </TabPanel>

                        <TabPanel>
                            <GridDevices applicationId={this.applicationId} clienteId={detalhes.cliente?.value ?? false} />
                        </TabPanel>
                        <TabPanel>
                            <GridMulticastGroups applicationId={this.applicationId} />
                        </TabPanel>
                    </Tabs>
                    : this.renderNameAndDescriptionFormContent()
                }


                {!this.props.isQuickRegister &&
                    <div className="hdv-btn-group">
                        {
                            tab === 0 ?
                                <ButtonsForm
                                    route="/lns/application"
                                    edit={this.applicationId ? true : false}
                                    cooldown={this.state.cooldown}
                                    buttons={[
                                        {
                                            method: "post",
                                            button: <button onClick={() => this.saveAction(false)} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                                        },

                                        {
                                            method: "post",
                                            button: <button style={{ display: this.applicationId ? "none" : "inline-block" }} onClick={() => this.saveAction(true)} className="hdv-btn-forms hdv-btn-greenlight">Salvar e Cadastrar um Novo</button>
                                        },

                                        {
                                            method: "patch",
                                            button: <button onClick={() => this.saveAction(false)} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                                        },
                                    ]}
                                />
                                : null
                        }

                        <Link to="/lns/application">
                            <button className="hdv-btn-forms hdv-btn-orange">Cancelar</button>
                        </Link>
                    </div>
                }
            </div>
        )
    }
}

export default Form